const LOGO_URL = 'https://static.readdy.ai/image/b56ddf5676badcd01c30e06215815ec0/37b9a51629d81ba8d66d9729e868ebad.png';

const features = [
  'Free Consultations Available',
  'Personalized Support',
  'Goal-Focused Coaching',
];

const quickLinks = [
  { label: 'About', id: 'solution' },
  { label: 'Benefits', id: 'benefits' },
  { label: 'How It Works', id: 'how-it-works' },
  { label: 'Contact', id: 'consultation' },
];

export default function FooterSection() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#F5EDE6]">
      {/* CTA Strip */}
      <div className="bg-[#D4896A] py-10 px-6 text-center">
        <p
          className="text-2xl md:text-3xl font-bold text-white mb-6"
          style={{ fontFamily: '\'Playfair Display\', serif' }}
        >
          Take the First Step Today
        </p>
        <button
          onClick={() => scrollTo('consultation')}
          className="inline-block bg-white text-[#D4896A] px-8 py-3 rounded-full font-semibold text-base hover:bg-[#FAF8F5] transition-colors cursor-pointer whitespace-nowrap"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          Book Your Free Consultation
        </button>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 flex items-center justify-center">
                <img
                  src={LOGO_URL}
                  alt="Brand New You Logo"
                  className="w-12 h-12 object-contain"
                />
              </div>
              <div>
                <p
                  className="text-lg font-bold text-[#2C2C2C]"
                  style={{ fontFamily: '\'Playfair Display\', serif' }}
                >
                  Brand New You
                </p>
                <p
                  className="text-xs text-[#8A7A6A]"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Life Coaching in Lubbock, Texas
                </p>
              </div>
            </div>
            <p
              className="text-sm text-[#6B6B6B] leading-relaxed mb-6 max-w-sm"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Helping people in Lubbock and beyond gain clarity, build confidence, and move
              forward toward the life they truly want.
            </p>
            <div className="space-y-2">
              {features.map((f) => (
                <div key={f} className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-[#D4896A] text-base" />
                  </div>
                  <span
                    className="text-sm text-[#6B6B6B]"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    {f}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p
              className="text-xs font-semibold uppercase tracking-widest text-[#8A7A6A] mb-6"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Quick Links
            </p>
            <div className="space-y-3">
              {quickLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="block text-sm text-[#2C2C2C] hover:text-[#D4896A] transition-colors cursor-pointer"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p
              className="text-xs font-semibold uppercase tracking-widest text-[#8A7A6A] mb-6"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Location
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-[#D4896A] text-base" />
                </div>
                <p
                  className="text-sm text-[#6B6B6B]"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Lubbock, Texas
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-phone-line text-[#D4896A] text-base" />
                </div>
                <p
                  className="text-sm text-[#6B6B6B]"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Free consultations available
                </p>
              </div>
              <button
                onClick={() => scrollTo('consultation')}
                className="mt-2 text-sm font-medium text-[#D4896A] hover:underline cursor-pointer"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Book yours today &rarr;
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#E0D0C4] py-6 px-6">
        <p
          className="text-center text-xs text-[#8A7A6A]"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          &copy; {new Date().getFullYear()} Brand New You &mdash; Life Coaching in Lubbock, Texas. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
